<template>
  <div class="notify">
    <div class="content" :class="alertType">
      <div class="icon" :class="{ 'snack-loading': alertType === 'info' }">
        <i v-if="alertType === 'info'" class="icon icon-loading" />
        <i v-if="alertType === 'error'" class="icon icon-error" />
        <i v-if="alertType === 'success'" class="icon icon-success" />
      </div>
      <div class="message">
        {{ firstTitle }} <span class="typo-semibold">{{ title }}</span> <span v-html="message"></span>
      </div>
      <div v-if="!hideCloseIcon" class="close ml-1" @click="onClose">
        <i class="icon icon-close" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapMutations } from 'vuex';
import { mutations } from '@/store/iframe/types';

export default defineComponent({
  name: 'GfAlert',
  props: {
    title: {
      type: String,
      default: 'Importing',
    },
    firstTitle: {
      type: String,
    },
    message: {
      type: String,
      default: 'preset from your Shopify Theme',
    },
    alertType: {
      type: String,
      default: '',
    },
    hideCloseIcon: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...mapMutations('iframe', {
      ALERT: mutations.ALERT,
    }),
    onClose() {
      this.ALERT({ show: false });
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
.snack-loading {
  animation: spin 1s linear infinite;
}
.notify {
  width: auto;
  height: auto;

  .content {
    display: flex;
    justify-content: between;
    max-width: 624px;
    min-width: 352px;
    min-height: 54px;
    left: 50%;
    transform: translate(-35%);
    top: 72px;
    z-index: 999999;
    position: fixed;
    padding: 16px;
    border-radius: 3px;
  }

  .close {
    cursor: pointer;

    img {
      width: 16px;
      height: 16px;
    }

    // padding: 4px;
    height: 22px;
    .icon {
      margin-right: 0;
      top: 0;
    }
  }

  .message {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
    margin-left: 8px;
  }

  .icon {
    width: 20px;
    height: 20px;
    font-size: 20px;
    position: relative;
    @include flex-center;
    .icon-success {
      color: map-get($accent-green-ui-kit, '400');
    }

    .icon-error {
      color: map-get($accent-red-ui-kit, '300');
    }

    .icon-loading {
      color: map-get($primary-blue-ui-kit, '400');
    }
  }
}
.success {
  background: map-get($accent-green-ui-kit, '100');
}

.info {
  background: map-get($primary-blue-ui-kit, '100');
}

.error {
  background: map-get($accent-red-ui-kit, '50');
  border-radius: 3px;

  .message {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: map-get($accent-red-ui-kit, '300');
  }
}
</style>
